"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regExpCheckPassword = exports.regExpSearchString = exports.REG_PASSWORD_SEPARATED = void 0;
const types_1 = require("../../containers/AccountProvider/types");
exports.REG_PASSWORD_SEPARATED = {
    symbolsCounts: /.{6}/,
    latinLetter: /^[a-zA-Z0-9()*_\-!;:#$%^&*,."'\][]+$/,
};
// Function to sanitize and create a RegExp from the search term
const regExpSearchString = (valueSearch) => new RegExp(valueSearch.replace(/[^a-zа-яё0-9\s-]/gi, ''), 'i');
exports.regExpSearchString = regExpSearchString;
const regExpCheckPassword = (value) => {
    const errors = [];
    if (!new RegExp(exports.REG_PASSWORD_SEPARATED.latinLetter).test(value)) {
        errors.push({
            type: types_1.EChangePassword.RENEWED,
            text: 'mandatory entry in Latin',
        });
    }
    if (!new RegExp(exports.REG_PASSWORD_SEPARATED.symbolsCounts).test(value)) {
        errors.push({
            type: types_1.EChangePassword.RENEWED,
            text: 'at least 6 characters',
        });
    }
    return errors;
};
exports.regExpCheckPassword = regExpCheckPassword;
//# sourceMappingURL=index.js.map